import { InterruptionButtons as InterruptionButtonsComponent } from './InterruptionButtons.component';
import { connector } from './InterruptionButtons.connector';

export const InterruptionButtons = connector(InterruptionButtonsComponent);
